function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\u526A\\u4E0B",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(4.000000, 2.000000)",
  fill: "#555555"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.5,12 C5.43299662,12 7,13.5670034 7,15.5 C7,17.4329966 5.43299662,19 3.5,19 C1.56700338,19 0,17.4329966 0,15.5 C0,13.5670034 1.56700338,12 3.5,12 Z M3.5,14 C2.67157288,14 2,14.6715729 2,15.5 C2,16.3284271 2.67157288,17 3.5,17 C4.32842712,17 5,16.3284271 5,15.5 C5,14.6715729 4.32842712,14 3.5,14 Z",
  id: "Oval",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.5,12 C14.4329966,12 16,13.5670034 16,15.5 C16,17.4329966 14.4329966,19 12.5,19 C10.5670034,19 9,17.4329966 9,15.5 C9,13.5670034 10.5670034,12 12.5,12 Z M12.5,14 C11.6715729,14 11,14.6715729 11,15.5 C11,16.3284271 11.6715729,17 12.5,17 C13.3284271,17 14,16.3284271 14,15.5 C14,14.6715729 13.3284271,14 12.5,14 Z",
  id: "Oval-Copy",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle",
  transform: "translate(8.000000, 7.000000) scale(-1, 1) rotate(-31.000000) translate(-8.000000, -7.000000) ",
  points: "7 1.17552537 9 0 9 14 7 14"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle-Copy",
  transform: "translate(8.000000, 7.000000) rotate(-31.000000) translate(-8.000000, -7.000000) ",
  points: "7 1.17552537 9 0 9 14 7 14"
})));

function SvgCut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u526A\u4E0B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCut);
export default __webpack_public_path__ + "static/media/cut.78ec6ba6.svg";
export { ForwardRef as ReactComponent };